import React from 'react';
import { object, bool, func, string } from 'prop-types';

import { ButtonWrap } from './styles';
import { Title } from '../styled-components';
import { CommentInfo } from './comment-info';
import { SpinnerWithBackground, ButtonWithLoader } from '../../components/ui-helpers/';

export const CommentsModal = (props) => {
  const {
    title,
    text,
    onSave,
    payload,
    isLoading,
    onTextChange,
    onCloseModal,
  } = props;

  return (
    <React.Fragment>
      {isLoading && <SpinnerWithBackground />}

      <Title>
        {payload.readOnly
          ? 'Comment Details'
          : title}
      </Title>

      {payload.readOnly ?
        (
          <React.Fragment>
            <CommentInfo
              readOnly
              text={text}
              theme={null}
            />

            <ButtonWrap onClick={onCloseModal}>
              <ButtonWithLoader >
            Close
              </ButtonWithLoader>
            </ButtonWrap>
          </React.Fragment>
        ) :
        (<form onSubmit={onSave}>
          <CommentInfo
            text={text}
            onTextChange={onTextChange}
            theme="snow"
          />

          <ButtonWrap>
            <ButtonWithLoader type="submit">
            Save
            </ButtonWithLoader>
          </ButtonWrap>
        </form>)
      }
    </React.Fragment>
  );
};

CommentsModal.propTypes = {
  onSave: func.isRequired,
  text: string.isRequired,
  title: string.isRequired,
  isLoading: bool.isRequired,
  payload: object.isRequired,
  onCloseModal: func.isRequired,
  onTextChange: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modals/comments-modal/component.js